// extracted by mini-css-extract-plugin
export default {"fieldRoot":"FieldDateRangeController_fieldRoot__9CrAB","mobileMargins":"FieldDateRangeController_mobileMargins__0trlE"};